// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Stock_LowStockResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/stock/low_stock
 *
 * Returns products whose current stock is at or below the minimum
 * threshold for the first franchise of the current filter, joined with
 * `so_products.so_product_name`. Wire shape:
 * `dados: Stock_StockEnrichedRow[]`.
 *
 * @see Stock_StockEnrichedRow
 * @see So_stock_model::getLowStockProducts()
 */
import type { Stock_StockEnrichedRow } from './Stock_StockEnrichedRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Stock_LowStockResponseDados = Stock_StockEnrichedRow[];

export type Stock_LowStockResponse = ApiResponse<Stock_LowStockResponseDados>;

registerResponseContract('Stock_LowStockResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_stock_id:                            { type: 'number',  required: true },
      so_stock_product_id:                    { type: 'number',  required: true },
      so_stock_quantity:                      { type: 'number',  required: true },
      so_stock_minimum_quantity:              { type: 'number',  required: true },
      so_stock_location_id:                   { type: 'number',  required: false },
      so_stock_franchise_id:                  { type: 'number',  required: true },
      so_stock_updated_at:                    { type: 'string',  required: false },
      so_product_name:                        { type: 'string',  required: false },
      so_product_default_price:               { type: 'number',  required: false },
      so_stock_price:                         { type: 'number',  required: false },
      so_stock_effective_price:               { type: 'number',  required: false },
      so_product_franchise_id:                { type: 'number',  required: false },
      so_product_franchise_name:              { type: 'string',  required: false },
      so_stock_franchise_name:                { type: 'string',  required: false },
      so_stock_deficit:                       { type: 'number',  required: false },
      so_stock_is_low:                        { type: 'boolean', required: false },
      so_product_primary_image_thumbnail_url: { type: 'string',  required: false },
      so_product_track_stock:                 { type: 'number',  required: false },
      so_product_category_name:               { type: 'string',  required: false },
    },
  },
})
